import { render, staticRenderFns } from "./HealthAssess.vue?vue&type=template&id=86077d54&scoped=true"
import script from "./HealthAssess.vue?vue&type=script&lang=js"
export * from "./HealthAssess.vue?vue&type=script&lang=js"
import style0 from "./HealthAssess.vue?vue&type=style&index=0&id=86077d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86077d54",
  null
  
)

export default component.exports